import React from 'react'
import { Box } from '@mui/material'

export const VariedadLabel = ({ color, children }) => {
  if (!/^#[0-9a-f]{6}$/i.test(color || '')) return <>{children}</>

  return (
    <Box component="span" sx={{
      display: 'inline-block',
      maxWidth: '100%',
      boxSizing: 'border-box',
      verticalAlign: 'bottom',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      borderLeft: `3px solid ${color}`,
      background: `linear-gradient(${color}22, ${color}22), #FFFFFF`,
      color: '#172033',
      px: 0.45,
      borderRadius: '2px',
      lineHeight: 'inherit',
    }}>
      {children}
    </Box>
  )
}
